export default __webpack_public_path__ + "static/media/CitiBank.1d563da3.svg";